<template>
    <div class="box">
        <div class="box-offset">
            <div class="box-ttl">Add Notes</div>
            <div class="form mt-3">
                <div class="row mb-3">
                    <div class="col-md-12">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Notes</label>
                            <textarea
                                type="text"
                                class="form-control"
                                v-model="newComment"
                            ></textarea>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <h6>History</h6>
                        <div class="history-messages">
                            <div class="text-scroll">
                                <div class="todo-comments-block">

                                    <div class="comment-item"
                                         v-for="comment in listOfComments"
                                         :key="comment.id"
                                    >
                                        <div
                                            class="avatar"
                                            :style="{'background-image': comment.author.avatar ? getNameOfAvatar(comment.author.avatar): 'url(/img/svg/emptyAvatar.png)'}"
                                        ></div>
                                        <div class="item-inner">

                                            <div class="date-time"
                                                 v-if="comment.updated_at">
                                                {{formatDate(comment.updated_at)}}
                                            </div>
                                            <div class="date-time" v-else>{{formatDate(comment.created_at)}}</div>

                                            <div class="item-inner-content">
                                                <div class="item-inner-content-text">
                                                    <div class="item-ttl">
                                                        <h5>{{comment.author.name}} {{comment.author.last_name}}</h5>
                                                    </div>
                                                    <div class="form-group form-group-1 mb-0"
                                                         v-if="activeComment.id === comment.id"
                                                    >
                                                                <textarea
                                                                    v-model="comment.comment"
                                                                    class="form-control">
                                                                </textarea>
                                                    </div>
                                                    <p v-else>
                                                        <pre style="white-space: pre-wrap; font-family: 'Open Sans', sans-serif; font-size: 14px;">{{ comment.comment }}</pre>
                                                    </p>
                                                </div>
                                                <div class="action-block">
                                                    <a href="javascript:void(0)"
                                                       v-if="activeComment.id === comment.id"
                                                       class="img-btn edit-link ml-2"
                                                       @click="saveComment(comment)"
                                                    ><img src="/img/svg/check-5.svg" alt="save"></a>

                                                    <a href="javascript:void(0)"
                                                       v-else
                                                       class="img-btn edit-link ml-2"
                                                       @click="editComment(comment)"
                                                    ><img src="/img/svg/icons-pen.svg" alt="edit">
                                                    </a>
                                                    <button
                                                        class="img-btn delete-link"
                                                        @click="showDeleteModal(comment.id, 'notes')"
                                                        v-show="activeComment.id !== comment.id"
                                                    ><img src="/img/svg/on.svg" alt=""></button>

                                                    <ActionModal confirm-text="Yes"
                                                                 reject-text="No"
                                                                 :modalId="getDeleteModalId(comment.id, 'notes')"
                                                                 @confirm="deleteComment(comment.id)">
                                                        <template #body>
                                                            <div class="text-center mb-4">
                                                                <h4>
                                                                    Are you sure you want <br> to delete this item?
                                                                </h4>
                                                            </div>
                                                        </template>
                                                    </ActionModal>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="btns-wrap">
                            <button
                                class="btn btn--outline-primary w-100 w-sm-auto"
                                @click="reloadPage"
                            >
                                Cancel
                            </button>
                            <button
                                class="btn btn--secondary w-100 w-sm-auto "
                                @click="addNewComment"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import StyleHandler from "../../../../../../resources/js/mixins/StyleHandler";
import SiteClientsService from "../services/SiteClientsService";

export default {
    name: "Notes",
    components: {ActionModal},
    mixins:[DateConverter, ModalHandler, StyleHandler],
    props: {
        clientInfo: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            activeTab: null,
            listOfComments: this.clientInfo.comments ?? [],
            activeComment: {},
            newComment: null,
        }
    },
    methods: {
        async addNewComment() {
            if (!this.newComment || this.newComment.trim() === '') {
                this.$showErrorMessage('Your comment is empty');
            } else {
                try {
                    this.$showLoadingMessage()
                    const {data: response} = await SiteClientsService.addNewComment(this.clientInfo.id, this.newComment)
                    this.listOfComments.unshift(response)
                    this.newComment = ''
                    this.$showSuccessMessage('New comment was added')
                } catch (e) {
                    this.$showErrorMessage('New comment was not added');
                }
            }
        },
        async deleteComment(id) {
            this.$showLoadingMessage();
            this.listOfComments= this.listOfComments.filter((comment) => comment.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await SiteClientsService.deleteComment(id)
            } catch (error) {
                this.$showErrorMessage('This comment was not deleted. Please try again');
            }
        },
        editComment(comment) {
            this.activeComment = comment
        },
        async saveComment(comment) {
            if (!comment.comment || comment.comment.trim() === '') {
                this.$showErrorMessage('Your comment is empty');
            } else {
                this.$showLoadingMessage()
                try {
                    await SiteClientsService.updateComment(comment.id, comment.comment);
                    this.activeComment = {}
                    this.$showSuccessMessage('Your comment was updated!')
                } catch (e) {
                    this.$showErrorMessage('Your comment was not updated');
                }
            }

        },
    },
}

</script>

<style scoped>

</style>

